import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Entity('unit_twleve_excel_file_upload')
export class UnitTwelevFileUploadEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id",
    })
    id: number;

    @Column()
    randomId: string

    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "excel_file_name",
    })
    excelFileName: string


    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "excel_file_path",
    })
    filePath: string

    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "pdf_file_name",
    })
    pdfFileName: string

    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "original_file_name",
    })
    originalFileName: string

    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "pdf_file",
    })
    pdfFile: string


    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "buyer_name",
    })
    dropDown: string

    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "so_number",
    })
    soNumber: string


    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;


}